export var normalizeRoster = function normalizeRoster(_ref) {
  var followLabel = _ref.followLabel,
    followingLabel = _ref.followingLabel,
    followedPlayers = _ref.followedPlayers,
    roster = _ref.roster;
  // Create Set of followedPlayer ids for easy matching against roster
  var followedPlayersSet = new Set();
  followedPlayers === null || followedPlayers === void 0 ? void 0 : followedPlayers.forEach(function (_ref2) {
    var id = _ref2.id;
    return followedPlayersSet.add("".concat(id));
  });
  return roster === null || roster === void 0 ? void 0 : roster.map(function (_ref3) {
    var id = _ref3.id,
      useLastName = _ref3.useLastName,
      useName = _ref3.useName;
    var isFollowed = followedPlayersSet.has("".concat(id));
    return {
      alt: "".concat(useName, " ").concat(useLastName, " headshot"),
      id: id,
      isFollowed: isFollowed,
      followLabel: isFollowed ? followingLabel : followLabel,
      name: useLastName,
      superName: useName,
      type: "player"
    };
  }).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });
};